import { push } from 'react-router-redux'

import { STUB } from 'urls'

export default function GameSwitcher({ dispatch }) {
    return next => action => {
        const isGameSwitchedOff = action && action.payload && action.payload.statusCode === 503

        if (isGameSwitchedOff) {
            dispatch(push(STUB))
        }

        return next(action)
    }
}



// WEBPACK FOOTER //
// ./state/middlewares/game_switcher.js